import React from 'react';

const QoplaMenuPage = ({ navigateTo }) => {
   return (
    <div className="flex flex-col h-screen">
       {/* Header with Back Button */}
       <div className="p-4 bg-orange-50 border-b border-gray-200 flex items-center">
            <button
                onClick={() => navigateTo('home')}
                className="inline-flex items-center text-red-700 hover:text-red-900 transition duration-150 group"
            >
                <svg className="w-5 h-5 mr-2 transform group-hover:-translate-x-1 transition-transform duration-150" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 19l-7-7m0 0l7-7m-7 7h18"></path></svg>
                Tillbaka till Hem
            </button>
             <h1 className="text-xl font-serif font-bold text-center text-red-800 flex-grow">
                Online Meny
            </h1>
       </div>
       {/* Iframe Container */}
       <div className="flex-grow w-full pb-[20%]"> {/* Changed h-screen to h-full and added flex-grow */}
            <iframe
                src="https://qopla.com/restaurant/grande---italiensk-restaurang---pizzeria-eslov/qRbgPBXk4N/order" // User provided URL
                className="w-full h-full border-none"
                title="Grande Beställning Online"
            ></iframe>
       </div>
    </div>
  );
};

export default QoplaMenuPage;